/* eslint-disable react-hooks/exhaustive-deps */
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { orderBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsEditExistingMod,
  selectIsEditMod,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { findKeyBaseOnValue, reasonForChangeOption } from '../../ModificationsUtils';

export const ReasonForChange = () => {
  const { control, getValues, setValue, setError, clearErrors, register } = useFormContext();
  const { t } = useTranslation();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const isUndoModal = useSelector(selectIsUndoModal);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const dispatch = useDispatch();
  register('reasonForChangeId');
  const reasonForChange = 'reasonForChange';
  const trHousingType: string = useWatch({ name: 'travelerRequestedHousingType' });
  const aHousingType: string = useWatch({ name: 'actualHousingType' });
  const reasonForChangeWatch: string = useWatch({ name: 'reasonForChange' });
  const [disabledOption, setDisabledOption] = useState<Array<{ ID: number; Description: string }>>([]);
  const [options, setOptions] = useState([]);

  const tooltipMsg = (
    <span style={{ fontSize: '11px' }}>
      {'Disabled since Traveler Requested and Actual Housing Type are <b>not</b> the same.'}
    </span>
  );
  const getId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(reasonForChangeOption, value);
    return selectedOption.Id;
  };
  const onSelectionChange = (value?: string) => {
    setValue(reasonForChange, value);
    setValue('reasonForChangeId', getId(value));
    if (value) {
      clearErrors(reasonForChange);
    }
  };

  useEffect(() => {
    // sometime reasonForChange field getting null setting this default value
    if (trHousingType === aHousingType && reasonForChangeWatch === null) {
      setValue(reasonForChange, 'Traveler Requested');
      setValue('reasonForChangeId', 5);
      clearErrors(reasonForChange);
    } else {
      if (getValues(reasonForChange)) {
        setValue('reasonForChangeId', getId(getValues(reasonForChange)));
        clearErrors(reasonForChange);
      }
    }

    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal, isEditExistingMod]);

  useEffect(() => {
    if (trHousingType !== aHousingType) {
      setDisabledOption([{ ID: 5, Description: 'Traveler Requested' }]);
      if (reasonForChangeWatch === 'Traveler Requested') {
        setValue('reasonForChangeId', null);
        setValue(reasonForChange, null);
        setError(reasonForChange, {});
      }
    } else {
      setDisabledOption([]);
    }
  }, [trHousingType, aHousingType, reasonForChangeWatch]);

  const getResaonForChangeOptions = async () => {
    const reasonForChangeOptions = await getSearchFilterOptions('privateHousingOptionType');

    if (reasonForChangeOptions.length > 0) {
      const newOptions = reasonForChangeOptions.map(item => ({ ID: parseInt(item.value), Description: item.name }));
      setOptions(orderBy(newOptions, 'ID', 'asc'));

      if (getValues(reasonForChange)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(reasonForChange));
        setValue('reasonForChangeId', selectedOption?.ID);
        clearErrors(reasonForChange);
      } else {
        setError(reasonForChange, {});
      }
    }
  };

  useEffect(() => {
    getResaonForChangeOptions();
  }, []);

  return (
    <Controller
      control={control}
      name={reasonForChange}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          disabledOptions={disabledOption}
          name={reasonForChange}
          label={t('placement.placementMods.reasonForChange')}
          standard={true}
          options={options ?? []}
          handleChange={e => {
            if (trHousingType !== aHousingType && e.target.value === 'Traveler Requested') {
              return null;
            } else {
              onSelectionChange(e.target.value);
              onChange(e.target.value);
            }
          }}
          inputValue={getValues(reasonForChange) ?? ''}
          readOnly={!isModEdit}
          disabled={isSaveModApiCalling}
          {...rest}
          tooltipMsg={tooltipMsg}
        ></FormInputDropdown>
      )}
    />
  );
};
